var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#D3E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3684 15.4286V20.4286H13.4211V15.4286H11.3684ZM15.4737 15.4286V20.4286H17.5263V15.4286H15.4737ZM10 24H23V21.8571H10V24ZM19.5789 15.4286V20.4286H21.6316V15.4286H19.5789ZM16.5 9L10 12.5714V14H23V12.5714L16.5 9Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b3c983f145801cd473c23def0e777b60.svg";
export { ForwardRef as ReactComponent };